import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMask from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueYoutube from 'vue-youtube'
 
import vco from "v-click-outside"
import { estPagePublique } from '@/helpers/pagesPubliques'

// Neutralise les erreurs levées par l'observateur de Quill sur un éditeur
// démonté (cf. src/helpers/quillPatch.js). À appliquer avant tout montage.
import appliquerCorrectifQuill from '@/helpers/quillPatch'
appliquerCorrectifQuill()

import router from './router'
import store from '@/state/store'
import i18n from './i18n'
import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from 'vue-loaders';
import "@/assets/scss/app.scss";
 

import VueAxios from 'vue-axios'
import axios from 'axios'

// Skip ngrok-free's browser interstitial on XHR calls (otherwise ngrok returns
// its HTML warning page without CORS headers → surfaces as a "CORS error").
axios.defaults.headers.common['ngrok-skip-browser-warning'] = 'true'

// Toute réponse 401 (token révoqué/expiré, déconnexion dans un autre onglet)
// purge la session locale et renvoie au login. Le guard du router ne suffit pas :
// il ne re-vérifie le token qu'à la navigation, pas quand il meurt côté serveur.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('auth')
      // Sur une page publique (lien de réinitialisation, inscription…),
      // un 401 est attendu : rediriger chasserait l'utilisateur de la page
      // qu'il vient d'ouvrir.
      if (!estPagePublique(router.currentRoute.path)) {
        router.push('/login')
      }
    }
    return Promise.reject(error)
  }
)

import { initFirebaseBackend } from './helpers/firebase/authUtils';

import { configureFakeBackend } from './helpers/fakebackend/fake-backend';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

Vue.config.productionTip = false
Vue.use(VueAxios, axios)

Vue.use(VueLoaders)
Vue.use(VueYoutube)
Vue.use(BootstrapVue)
Vue.use(vco)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2);
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
